import api from '@/libs/axios'

export default {
  async create(payload) {
    const response = await api.post('/admin/newbie-missions', payload)
    return response.data.data.new_document || null
  },
  async update(payload) {
    return await api.put('/admin/newbie-missions', payload)
  },
  async delete(payload) {
    return await api.delete('/admin/newbie-missions', {
      data: payload,
    })
  },
  async getList(params) {
    return await api.get('/admin/newbie-missions', {
      params,
    })
  },
  async get(params) {
    let response = await api.get('/admin/newbie-missions/detail', {
      params,
    })
    return response.data.data.document || null
  },
  async updateDisplayOrder(payload) {
    return await api.post('/admin/newbie-missions/update-display-order', payload)
  },
  async getPublicNewbieMissionDate() {
    let response = await api.get('/admin/configs/detail', { params: { key: 'PUBLIC_NEWBIE_MISSION_DATE' } })
    return response.data.data.document || null
  },
  async updatePublicNewbieMissionDate(payload) {
    let response = await api.put('/admin/configs', payload)
    return response
  },
}
